/** @jsxImportSource @emotion/react */
import { css, CSSObject } from "@emotion/react";

import { ReactNode } from "react";

import Typography from "@mui/material/Typography";

import { useStyles } from "../styles";

export interface InnerTopProps {
  title: string | ReactNode;
  description?: string;
}

const InnerTop = ({ title, description }: InnerTopProps) => {
  const {
    innerTopTitle,
    innerTopDescription,
    innerTopShared,
    innerTopContainer
  } = useStyles();

  return (
    <div css={css(innerTopContainer)} data-testid="inner-top-container">
      <Typography
        variant="body2Medium"
        component="div"
        sx={[innerTopTitle, innerTopShared] as CSSObject[]}
      >
        {title}
      </Typography>

      {description && (
        <Typography
          variant="body2Regular"
          component="div"
          sx={[innerTopDescription, innerTopShared] as CSSObject[]}
        >
          {description}
        </Typography>
      )}
    </div>
  );
};

export { InnerTop };
